import React, { useState } from 'react';
import PropTypes from 'prop-types';

export const PasswordChangeContext = React.createContext();

const PasswordChangeContextProvider = ({ children }) => {
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [currentPasswordError, setCurrentPasswordError] = useState(null);
    const [newPasswordError, setNewPasswordError] = useState(null);
    const [confirmPasswordError, setConfirmPasswordError] = useState(null);

    const [passwordScore, setPasswordScore] = useState(0);

    return (
        <PasswordChangeContext.Provider
            value={{
                currentPassword,
                newPassword,
                confirmPassword,
                setCurrentPassword,
                setNewPassword,
                setConfirmPassword,
                currentPasswordError,
                newPasswordError,
                confirmPasswordError,
                setCurrentPasswordError,
                setNewPasswordError,
                setConfirmPasswordError,
                passwordScore,
                setPasswordScore,
            }}
        >
            {children}
        </PasswordChangeContext.Provider>
    );
};

PasswordChangeContextProvider.propTypes = {
    children: PropTypes.element.isRequired,
};

export default PasswordChangeContextProvider;
